module.exports = __webpack_public_path__ + "img/bg_01@2x.923b3283.png";